import RootStore from 'stores/RootStore'
import { trackInAmplitude } from 'utils/tracking/amplitude'
import { AmplitudeEvent } from 'utils/tracking/amplitude/amplitude.interface'
import { isOk } from 'utils/url/status'
import { TurnstileInstance } from '@marsidev/react-turnstile'
import { MutableRefObject } from 'react'

export type CaptchaTriggerSource = 'ctaClick' | 'finalize'

type Params = {
  rootStore: RootStore
  captchaRef?: MutableRefObject<TurnstileInstance | null> | null
  source: CaptchaTriggerSource
}

export const handleCaptcha = async ({
  rootStore,
  captchaRef,
  source
}: Params): Promise<void> => {
  const {
    navigation: { currentPageInSession },
    traversal: { traversalId },
    captcha: { captchaFlowStatus, setCaptchaFlowStatus, getCaptchaStatus }
  } = rootStore

  trackInAmplitude(AmplitudeEvent.CaptchaInitiated, {
    currentPage: currentPageInSession,
    captchaTriggerSource: source
  })

  if (captchaFlowStatus === 'success') {
    trackInAmplitude(AmplitudeEvent.CaptchaSkipped, {
      currentPage: currentPageInSession
    })
    return
  }

  if (captchaFlowStatus === 'inProgress') {
    trackInAmplitude(AmplitudeEvent.CaptchaAlreadyInProgress, {
      currentPage: currentPageInSession
    })
    return
  }

  setCaptchaFlowStatus('inProgress')

  trackInAmplitude(AmplitudeEvent.CaptchaGetStatus, {
    currentPage: currentPageInSession
  })

  try {
    const response = await getCaptchaStatus(traversalId)
    if (response?.status && isOk(response.status)) {
      trackInAmplitude(AmplitudeEvent.CaptchaStatusIsValid, {
        currentPage: currentPageInSession
      })
      setCaptchaFlowStatus('success')
      return
    }
  } catch {
    trackInAmplitude(AmplitudeEvent.CaptchaGetStatusError, {
      currentPage: currentPageInSession
    })
  }

  trackInAmplitude(AmplitudeEvent.CaptchaChallengeStarted, {
    currentPage: currentPageInSession
  })

  if (captchaRef?.current) {
    try {
      captchaRef.current.execute?.()
      trackInAmplitude(AmplitudeEvent.CaptchaExecuteSuccess, {
        currentPage: currentPageInSession
      })
    } catch (error) {
      trackInAmplitude(AmplitudeEvent.CaptchaExecuteError, {
        currentPage: currentPageInSession,
        error
      })
      setCaptchaFlowStatus('error')
    }
  }
}
